import { VIEWINGS_FILTER_PARAM } from '../../../../RentalPortalViewing'

export const VIEWINGS_FILTER_PARAM_LIST = Object.values(VIEWINGS_FILTER_PARAM)

export const VIEWINGS_FILTER_DAY_PARTS_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/
